__turbopack_context__.v({
  "approachSection": "styles-module__EsSHTq__approachSection",
  "content": "styles-module__EsSHTq__content",
  "icon": "styles-module__EsSHTq__icon",
  "iconActive": "styles-module__EsSHTq__iconActive",
  "iconInactive": "styles-module__EsSHTq__iconInactive",
  "leftBlock": "styles-module__EsSHTq__leftBlock",
  "pinWrapper": "styles-module__EsSHTq__pinWrapper",
  "rightBlock": "styles-module__EsSHTq__rightBlock",
  "secondaryText": "styles-module__EsSHTq__secondaryText",
  "stickyContainer": "styles-module__EsSHTq__stickyContainer",
  "subtitle": "styles-module__EsSHTq__subtitle",
  "text": "styles-module__EsSHTq__text",
  "title": "styles-module__EsSHTq__title",
  "word": "styles-module__EsSHTq__word",
});
